import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FreightQuotationFormComponent } from "../freight-quotation-form/freight-quotation-form.component";
import { SaleOrderLineAddressDto } from "../../../core/models/orders/saleOrderLineAddressDto";

@Component({
  selector: "jni-freight-quotation-detail",
  templateUrl: "./freight-quotation-detail.component.html",
  styleUrls: ["./freight-quotation-detail.component.scss"],
  imports: [CommonModule, FreightQuotationFormComponent],
})
export class FreightQuotationDetailComponent {
  @Input() saleOrderId = "";
  @Input() purchaseSaleOrderId = "";
  @Input() quoteIdFromModal!: number;
  @Input() accountNumber = "";
  @Input() partyNumber = "";
  @Input() jobName = "";
  @Input() selectedLineItems: SaleOrderLineAddressDto[] = [];
  @Output() closeModalEvent = new EventEmitter();
  moduleName = "Orders";

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
